import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../../../services/Auth/auth.service';
import { BookingCardComponent } from "../../../booking-card/booking-card.component";
import { Booking, BookingService } from '../../../../services/Booking/booking.service';
import { CancelBookingOverlayComponent } from "../../cancel-booking-overlay/cancel-booking-overlay.component";

@Component({
    selector: 'app-upcoming',
    imports: [
    CommonModule,
    BookingCardComponent,
    CancelBookingOverlayComponent
],
    templateUrl: './upcoming.component.html',
    styleUrl: './upcoming.component.scss'
})
export class UpcomingComponent {
    public isCancelOverlayOn: boolean = false
    public bookingToCancel: Booking | null = null

    constructor(
        public authService: AuthService,
        public bookingService: BookingService
    ) {

    }

    onCancel(booking: Booking) {
        console.log(booking)
        this.bookingToCancel = booking
        this.isCancelOverlayOn = true
    }

    onCancelExecute() {
        console.log('Execute cancel booking')
        if(this.bookingToCancel) {
            this.bookingService.onCancelBooking(this.bookingToCancel)
        }

        this.bookingToCancel = null
        this.isCancelOverlayOn = false
    }

    closeOverlay() {
        this.bookingToCancel = null
        this.isCancelOverlayOn = false
    }
}
